import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Paper from 'material-ui/Paper';
import RaisedButton from 'material-ui/RaisedButton';
import { reduxForm, Field } from 'redux-form';
import { TextField } from 'redux-form-material-ui';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import Theme from '../theme';
import * as authActions from '../redux/modules/auth';
import Logo from '../assets/images/logo.png';
import i18n from '../translations/i18n';

/*
Styled components
 */
const Container = styled.div`
  min-width: 320px;
  max-width: 400px;
  height: auto;
  position: absolute;
  top: 20%;
  left: 0;
  right: 0;
  margin: auto;
`;

const StyledPaper = styled(Paper)`
  padding: 20px !important;
  overflow: auto !important;
`;

const LogoContainer = styled.div`
  background-color: white;
  text-align: center;
`;

const LogoImage = styled.img`
  width: 190px;
`;

const StyledSubmitButton = styled(RaisedButton)`
  float: right;
`;

/*
PropTypes / DefaultProps
 */
const propTypes = {
  authenticated: PropTypes.bool,
  loginUser: PropTypes.func,
  handleSubmit: PropTypes.func,
  t: PropTypes.func,
};

const defaultProps = {
  authenticated: false,
};

class LoginPage extends React.Component {
  /*
    Lifecycle methods
   */
  componentWillMount() {
    if (this.props.authenticated) {
      browserHistory.push('/');
      return;
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.authenticated) {
      browserHistory.push('/');
      return;
    }
  }

  /*
    Custom methods
   */
  handleLoginSubmit = (values) => {
    const { username, password } = values;
    this.props.loginUser(username, password);
  };

  render() {
    const { handleSubmit } = this.props;

    return (
      <MuiThemeProvider muiTheme={Theme}>
        <Container>
          <StyledPaper>
            <LogoContainer>
              <LogoImage src={Logo} />
            </LogoContainer>
            <form onSubmit={handleSubmit(this.handleLoginSubmit)}>
              <Field
                floatingLabelFixed
                component={TextField}
                name="username"
                floatingLabelText={this.props.t('username')}
                fullWidth
              />
              <Field
                floatingLabelFixed
                component={TextField}
                name="password"
                floatingLabelText={this.props.t('password')}
                fullWidth
                type="password"
              />
              <div>
                <StyledSubmitButton type="submit" label={this.props.t('login')} primary />
              </div>
            </form>
          </StyledPaper>
        </Container>
      </MuiThemeProvider>
    );
  }
}

function validate(formProps) {
  const errors = {};

  if (!formProps.username) {
    errors.username = 'Username is required';
  }

  if (!formProps.password) {
    errors.password = 'Password is required';
  }

  return errors;
}

function mapStateToProps(state) {
  return {
    authenticated: state.auth.authenticated,
  };
}

LoginPage.defaultProps = defaultProps;
LoginPage.propTypes = propTypes;

const LoginPageWrapped = reduxForm({ form: 'login', validate })(LoginPage);
const extended = translate(['translations'], { i18n })(LoginPageWrapped);
export default connect(mapStateToProps, authActions)(extended);



// WEBPACK FOOTER //
// ./src/containers/LoginPage.js